import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

const namespace = 'entities';
export const keyPrefix = 'edit_department_info_form';
export const useEditDepartmentInfoFormTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    title: 'Изменить данные подразделения',
    fields: {
      name: 'Название',
      description: 'Описание',
    },
    submit: 'Сохранить',
    cancel: 'Отмена',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Edit department info',
    fields: {
      name: 'Name',
      description: 'Description',
    },
    submit: 'Save',
    cancel: 'Cancel',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Editar información del departamento',
    fields: {
      name: 'Nombre',
      description: 'Descripción',
    },
    submit: 'Guardar',
    cancel: 'Cancelar',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Editar informações do departamento',
    fields: {
      name: 'Nome',
      description: 'Descrição',
    },
    submit: 'Salvar',
    cancel: 'Cancelar',
  },
}) as Record<string, unknown>;
